import React from "react";
import styles from "./IconButton.module.scss";

/**
 * IconButton — kompakt, ikon-only veya ikon+text buton.
 *
 * `Button` ile fark: IconButton kare/yuvarlak, ikon-merkezli; toolbar
 * mikro-aksiyonları (prev/next, settings, filter trigger) için.
 *
 * variant: "ghost" (transparent, hover surface) | "solid" (brand bg) |
 *          "outlined" (border'lı, surface bg)
 * size:    "sm" (30px) | "md" (36px) | "lg" (44px) | "auto" (içeriğe göre)
 *
 * `active` prop'u veya `data-active` attribute'u brand vurgusu verir.
 * Calendar feature'da yıllarca kullanılan pattern; de-Bootstrap kampanyası Faz 8'de
 * design-system'e promote edildi.
 */
const IconButton = React.forwardRef(
  (
    {
      as: Tag = "button",
      variant = "ghost",
      size = "md",
      active,
      ariaLabel,
      title,
      children,
      ...rest
    },
    ref
  ) => (
    <Tag
      ref={ref}
      type={Tag === "button" ? rest.type || "button" : undefined}
      className={styles.btn}
      data-variant={variant}
      data-size={size}
      data-active={active || undefined}
      aria-label={ariaLabel}
      title={title || ariaLabel}
      {...rest}
    >
      {children}
    </Tag>
  )
);
IconButton.displayName = "IconButton";

export default IconButton;
